// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3goQW","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3aNOm"};